module.exports = __webpack_public_path__ + "img/noProductImageForComparison.b23a933b.svg";